import React, { useCallback } from 'react'
import Sheet from 'components/utils/Sheet'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import TextButton from 'LuxKit/Button/TextButton'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { hasSelectedRooms } from 'lib/offer/offerPageUtil'
import Group from 'components/utils/Group'

interface Props {
  selectedRooms: boolean
}

function BedbankMultiRoomNoDatesCTA({ selectedRooms }: Props) {
  const offerPageDispatch = useOfferPageDispatch()

  const handleCheckAvailabilityClick = useCallback(() => {
    offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: selectedRooms ? 'checkin' : 'capacity' })
  }, [offerPageDispatch, selectedRooms])

  return <Sheet padding={20} tabletPadding={0} background="neutral-eight">
    <Group direction="vertical" desktopDirection="horizontal" desktopHorizontalAlign="end">
      <TextButton kind="primary" onClick={handleCheckAvailabilityClick} size="large" fit="mobile-full-width">
        Check availability
      </TextButton>
    </Group>
  </Sheet>
}

export default withOfferPageState(state => ({
  selectedRooms: hasSelectedRooms(state.rooms),
}), BedbankMultiRoomNoDatesCTA)
